import { render, staticRenderFns } from "./uvAllForm.vue?vue&type=template&id=5696b1d8&scoped=true&"
import script from "./uvAllForm.vue?vue&type=script&lang=js&"
export * from "./uvAllForm.vue?vue&type=script&lang=js&"
import style0 from "./uvAllForm.vue?vue&type=style&index=0&id=5696b1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5696b1d8",
  null
  
)

export default component.exports